<template>
<div v-if="!(userInfo.isWorksheet && userInfo.isWorksheetVerify)" style="height:100%">
  <user-info />
</div>
<div v-else style="height:100%;">
  <div style="background:#fff;padding:0 24px 24px;height:100%;">
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="基本信息">
        <user-info style="padding-top:110px;" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="认证信息" force-render>
        <company-verify-info />
      </a-tab-pane>
    </a-tabs>
  </div>
</div>
</template>
<script>
import UserInfo from './UserInfo';
import CompanyVerifyInfo from './CompanyVerify/VerifyInfo.vue'
import {
  user,
  model
} from "eco-cli";
const {
  getToken,
  login,
  getInfo,
  setToken
} = user

export default {
  components: {
    UserInfo,
    CompanyVerifyInfo
  },
  data() {
    return {
      userInfo: {
        isWorksheet: false
      }
    }
  },
  mounted(){
    getInfo(true).then(res => {
      console.log("currentUser", res)
      this.userInfo = res;
    });
  },
  methods: {
    callback(key) {
      console.log(key);
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .ant-tabs-tab {
  line-height: 22px!important;
}
::v-deep .ant-tabs-bar .ant-tabs-nav {
  height: 40px!important;
}
::v-deep .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab {
  height: 40px!important;
  margin-right: 60px!important;
  color: #777;
}
::v-deep .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab-active {
  color: #222!important;
}
::v-deep .ant-tabs-bar {
  border-bottom: 1px solid #E8ECF1;
  margin-bottom: 12px!important;
  padding-top:20px;
}
</style>